import { ConfigTypes } from 'src/AppState/ConfigState/types';

export const features: ConfigTypes = {
    /* A */
    anniversaryInfoShow: false,
    accountTradingCountryClub: false,
    accountTradingDragonCircle: false,
    accountTradingRewardZone: false,
    accountTradingTartanClub: false,
    affiliateIdPromoCode: false,
    activityTimeframe: false,

    /* B */
    betBuilderReferralSwitchShow: true,

    /* C */
    casinoProviders: {
        casino: ['evolution', 'leap', 'pragmatic', 'sg-digital', 'relax', 'blueprint'],
        'live-casino': ['evolution', 'ezugi', 'pragmatic'],
        virtuals: ['pragmatic', 'leap'],
    },
    closureCodes: true,
    cmsHiddenTabs: ['headlineCarousel', 'promoCode'],
    complianceRestrictionSummary: false,
    contactPreferences: {
        preferences: ['email', 'sms', 'phone'],
        options: ['betting', 'casino'],
        newMarketing: true,
    },
    currencies: ['GBP', 'EUR', 'XTS'],
    cpfProperties: false,
    casinoStoreEnabled: false,

    /* D */
    dashboardTab: true,
    decimalLength: 2,
    depositLimitType: 'rollingType',
    depositLimitCalculationTypeConfigurable: true,
    depositRestriction: true,
    deceased: false,

    /* E */
    externalId: false,

    /* F */
    configurationManagerUI: false,
    failedWithdrawalsFundsEnabled: true,
    footerContentDefault: {
        description_text:
            'This site is operated by Playbook Gaming Ltd, trading as Playbook Engineering Ltd, (licence number {{licenceNumber}}) is licensed and regulated by the Gambling Commission. No.1 Poultry, London EC2R 8EJ.',
        licence_number: '50122',
        licence_url: 'https://www.gamblingcommission.gov.uk/public-register/business/detail/50122',
        cookies_url: 'https://betstgeorge.com/?account=static&static=cookie-policy',
        has_cookies: true,
    },
    footerLegalTextTab: true,
    fullNameProperties: false,

    /* H */
    hasNewMenu: true,
    hideDeleteImageButtonOnHomePageCarousel: false,
    hasXtremepush: false,

    /* G */
    gamprotect: false,
    gamstopNew: true,
    gamstopPpBlockedSuspendedActions: false,
    golfOnVirtuals: false,
    gtm: 'GTM-57ZGSSC',

    /* I */
    isAffordability: true,
    isPEP: true,
    identity: true,
    idMission: false,
    isBoostedPriceAvailable: true,
    indexNow: null,

    /* L */
    languages: [
        {
            value: 'en',
            label: 'English',
        },
    ],

    /* O */
    operatorFullName: 'Bet St George',

    /* P */
    personalId: false,
    paymentSearchWalletAddress: false,
    pof: true,
    promotionHistoryEnabled: true,

    /* R */
    realityCheckLimitedType: true,
    reportDownloadOptions: ['Export to CSV'],
    redirectToNewBetTickerPage: false,
    redirectToNewCMSPage: false,
    reportsV2: false,
    redirectToNewTradingPage: false,
    showRingFencedFunds: true,

    /* M */
    markersOfHarm: true,
    mobilePrefixDisabled: false,
    dopplernegroPrefix: false,
    minDepositAmount: '5',
    minWithdrawAmount: '1',
    minManualAdjustmentAmount: '1',

    /* N */
    newPragmatic: true,
    newPofSrg: true,
    notificationSounds: {
        newChat: 'ding',
        newBetReferral: 'ding',
    },

    /* S */
    sourceOfFunds: true,
    srgEnabled: true,
    starEventsLabel: 'Bet St George Events',
    showBonusEngine: true,
    showNewCustomerSettings: false,
    showRABInputs: true,
    showBonusCreator: true,

    /* T */
    tableauDashboards: true,
    tagManagementTab: true,
    topEvents: false,

    /* U */
    useExtraPlacesForEvents: false,
    usePaymentFormForUniverse: {
        type: 'multi-deposit',
        apiKey: 'T1QtMzUzODQyOkItcDEtMC02OTU3YzdlMi0wLTMwMmMwMjE0NmQ4MGFmZDM4YTc3NzAzYTE1YmJjMzcwYzEwYjk1M2E5ZDI0OWNhYzAyMTQ2YjI0Yzk4MmFhNWUxNGQzZjI5MGUxYjVmZTFlOWYyMDFmYWI0MTMw',
        environment: 'LIVE',
        cardAccounts: {
            GBP: '1003303152',
            EUR: '', // TODO - add this value when ready: https://portals.paysafe.com/portal/developer/webhooks
        },
        openBanking: null,
    },
    userTitleOptional: false,

    /* V */

    /* W */
    withdrawalsTabsShow: true,
    withdrawalStandardLimit: '5000',
    workbookView: {
        BackofficeReports: 'BackOfficeReports-BetStGeorge/DB-Casino',
        CasinoDashboard: 'CasinoDashboard-BetStGeorge/CasinoMainDashboard',
        ComplianceDashboard: 'ComplianceDashboard-BetStGeorge/ComplianceMainDashboard',
        MarketingDashboard: 'MarketingDashboard-BetStGeorge/MarketingMainDashboard',
        ProfitAndLossKPIs: 'ProfitandLossKPIs-BetStGeorge/DailyKPI',
        RacecourseDashboard: 'Racecourse-BetStGeorge/RacecourseMediaGroupDashboard',
        TransactionsDashboard: 'TransactionsDashboard-BetStGeorge/TransactionsMainDashboard',
        AccountBalances: 'AccountBalances-BetStGeorge/AccountBalances',
        RollingNetDeposits: 'RollingNetDeposits-BetStGeorge/RollingNetDeposits',
        BonusEngine: 'BonusEngine-BetStGeorge/CampaignLevel',
        SRGDashboard: 'SRGDashboard-BetStGeorge/DBAverageStakes',
        AuditsCustomerLists: 'AuditCustomerLists-BetStGeorge/Deposits',
    },
};
